import axios from 'axios';
import user from '../utils/user';

export default {
  async getAllConfigs() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/anti-fraud-configs`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async updateConfigs(id, payload) {
    delete payload.errors;
    delete payload.createdAt;
    delete payload.updatedAt;
    delete payload.deletedAt;

    try {
      const response = await axios.put(
        `${process.env.VUE_APP_API_VIDA_URL}/anti-fraud-configs/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getAntiFraudConfigHistory(id) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/anti-fraud-configs/${id}/logs`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getAntiFraudReview(id) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/anti-frauds/policies/${id}`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getAntiFraudReviewByPurchase(purchaseId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/anti-frauds/purchases/${purchaseId}`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async submitManualReview(payload) {
    try {
      const formDataSend = new FormData();
      const antiFraudTransactionId = payload.antiFraudTransactionId;

      const body = JSON.stringify({
        policyId: payload.policyId,
        comments: payload.comments,
        action: payload.action,
      });

      payload.attachments.forEach((file) => {
        formDataSend.append('files', file);
      });

      formDataSend.append('data', body);
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/anti-frauds/transactions/${antiFraudTransactionId}/reviews`,
        formDataSend,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
